// ============================================================================
// THE CYCLE — Stats Glossary page
// Thin wrapper around the shared GlossaryContent renderer.
// All stat definitions live in components/glossary/glossaryData.js.
// ============================================================================
import React from 'react';
import { Box, Typography } from '@mui/material';
import useMobile from '../hooks/useMobile';
import GlossaryContent from '../components/glossary/GlossaryContent';

const Glossary = () => {
  const { isMobile } = useMobile();

  return (
    <Box sx={{ p: { xs: 2, sm: 3 }, maxWidth: 1000, mx: 'auto' }}>
      <Box sx={{ mb: 2.5 }}>
        <Typography variant={isMobile ? 'h5' : 'h4'} fontWeight={800} gutterBottom>
          Stats Glossary
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Every metric on The Cycle — from CVR, ACVR, and the Cycle Index to trade analytics.
          The definitive reference for understanding the numbers.
        </Typography>
      </Box>

      <GlossaryContent variant="page" />
    </Box>
  );
};

export default Glossary;
